import React, { useEffect, useState } from 'react';

import { ProjectModel, TraceProviderModel, TraceSettings } from '../../../../../gamma-api';
import Settings from '../../../../components/Settings';

export interface ITracingTabProps {
  project?: ProjectModel;
  projectTraceProvider?: TraceProviderModel;
  onSave?: (traceSettings?: TraceSettings, traceProvider?: TraceProviderModel) => Promise<void>;
}

const TracingTab: React.FC<ITracingTabProps> = ({ project, projectTraceProvider, onSave }) => {
  const [traceSettings, setTraceSettings] = useState<TraceSettings | undefined>(project?.pipeline?.trace);
  const [traceProvider, setTraceProvider] = useState<TraceProviderModel | undefined>(projectTraceProvider);

  const onTracingSave = async () => {
    await onSave?.(traceSettings, traceProvider);
  };

  const onTracingChange = (traceSettings?: TraceSettings, traceProvider?: TraceProviderModel) => {
    setTraceSettings(traceSettings);
    setTraceProvider(traceProvider);
  };

  const onProjectAndProjectTraceProviderPropsChange = () => {
    setTraceSettings(project?.pipeline?.trace);
    setTraceProvider(projectTraceProvider);
  };
  useEffect(onProjectAndProjectTraceProviderPropsChange, [project, projectTraceProvider]);

  return (
    <Settings.Tracing
      traceProvider={traceProvider}
      traceSettings={traceSettings}
      onChange={onTracingChange}
      onSave={onTracingSave}
    />
  );
};

export default TracingTab;
